import styled, { css } from 'styled-components';
import { zoom } from '../../utils/styles/animation';

interface ItemProps {
  readonly margin?: string;
  readonly warningTitle?: Boolean;
  readonly padding?: string;
  readonly width?: string;
  readonly minWidth?: string;
  readonly maxWidth?: string;
  readonly responsive?: boolean;
  }


export const ModalSection = styled.section`
  background-color: rgba(0, 0, 0, 0.11);
  position: fixed;
  height: 100%;
  bottom: 0;
  right: 0;
  left: 0;
  top: 0;
  display: block;
  z-index: 999;
`;

export const ModalContainer = styled.div<ItemProps>`
  background-color: var(--BackgroundColor);
  box-shadow: 0 0 5px 1px rgba(0, 0, 0, 0.09);
  border-radius: 8px;
  width: min-content;
  max-width: 87%;
  max-height: 88vh;
  overflow-y: auto;
  overflow-x: auto;

  ${zoom({ time: '100ms', type: 'ease-in-out' })}

  ${props => {
    return `margin: ${props.margin};`;
  }};
  @media (min-width: 6px) and (max-width: 768px) {
    max-width: 98%
  }
  @media (min-width: 769px) and (max-width: 992px) {
    max-width: 93%
  }
  @media (min-width: 993px) and (max-width: 1200px) {
    max-width: 90%
  }
`;

export const ModalHeader = styled.div<ItemProps>`
  border-bottom: solid 1px var(--LightGray);
  background-color: var(--BackgroundGrey);
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  align-items: flex-start;
  flex-direction: column;
  display: flex;
  ${props => {
    return `padding:${props.padding};`;
  }}
`;

export const ModalHeaderTitle = styled.h2<ItemProps>`
  font-size: 26px;
  font-weight: 500;
  margin: 0;
  ${props => {
    return props.warningTitle ? `color:#F54B23;` : `color: #000000;`;
  }};
`;

export const ModalHeaderSubtitle = styled.span`
  color: var(--DarkGray);
  font-weight: 500;
  font-size: 14px;
`;

/**
 * the response variable is used to adapt the content of the modal in small resolutions to the total allowed by the screen
 */
export const ModalBody = styled.div<ItemProps>`
  background-color: var(--BackgroundColor);
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
  box-sizing: border-box;
  width: ${props => props.width ? props.width : 'auto'};
  ${props => props.minWidth ? 'min-width:' + props.minWidth + ';' : ''}
  max-width: ${props => props.maxWidth ? props.maxWidth : 'auto'};
  padding: ${props => props.padding ? props.padding : '0'};
  color: ${props => props.color ? props.color : 'auto'};
  overflow-x:auto;

  @media (max-width: 620px) {
    ${props => {
    let width: any;

    if (props.responsive) {
      width = 'width: 95vw;';
    }

    return css`{
      ${width}
    }`;
  }}
  }
`;


